/**
 * @license Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.metric-line-graph {
  position: relative;
  width: 50%;
}

#storybook-test-root .metric-line-graph {
  width: 100%;
}

.metric-line-graph__graph {
  height: 250px;
  width: 100%;
}

.metric-line-graph .metric-line-graph__line {
  fill: none;
  stroke: var(--secondary-text-color);
  stroke-width: 1px;
}

.metric-line-graph .metric-line-mask {
  stroke: black;
  stroke-width: 2px;
}

.metric-line-graph .metric-line-mask--selected {
  stroke: white;
}

.metric-line-graph__mask-fill--pass {
  fill: var(--pass-color);
}

.metric-line-graph__mask-fill--average {
  fill: var(--average-color);
}

.metric-line-graph__mask-fill--fail {
  fill: var(--fail-color);
}

.metric-line-graph .y-axis path {
  fill: none;
  stroke: none;
}

.metric-line-graph .y-axis text {
  font-family: var(--base-font-family);
  font-weight: var(--medium-font-weight);
  font-size: var(--subtext-font-size);
  color: var(--secondary-text-color);
}

.metric-line-graph__date-range {
  display: flex;
  flex-direction: row;

  color: var(--secondary-text-color);
  font-size: var(--subtext-font-size);
}

.metric-line-graph__legend {
  margin-top: var(--base-spacing);
  margin-bottom: var(--base-spacing);
}

.metric-line-graph__legend > div {
  display: flex;
  flex-direction: row;
  position: relative;
  margin-bottom: var(--base-spacing);
}

.metric-line-graph__legend-line {
  position: absolute;
  top: 50%;
}

.metric-line-graph__legend-line line {
  stroke: var(--secondary-text-color);
  stroke-width: 2px;
}

.metric-line-graph__legend-label {
  padding-left: var(--base-spacing);
  font-family: var(--base-font-family);
  font-size: var(--smaller-font-size);
  font-weight: var(--medium-font-weight);

  color: var(--secondary-text-color);
}

.metric-line-graph__legend-label > span {
  display: inline-block;
  width: 40px;
  padding-right: var(--base-spacing);

  color: var(--base-text-color);
}

.legend-label--highlighted {
  color: var(--base-text-color);
}

.metric-line-graph:first-child .hover-card {
  left: 100% !important;
}

.metric-line-graph:last-child .hover-card {
  left: initial !important;
  right: 100% !important;
}

#storybook-test-root .metric-line-graph:last-child .hover-card {
  left: initial !important;
  top: 10px;
  right: 10px !important;
}

.metric-line-graph__hover-card-data {
  width: 100%;
  padding: var(--base-spacing);
  padding-top: 0;
}

.metric-line-graph__hover-card-data > div:first-child {
  font-size: var(--title-font-size);
}

.metric-line-graph__hover-card-data > div:last-child {
  font-size: var(--smaller-font-size);
}
